import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      {/* Image Background */}
      <div className="hero-video-container">
        <img
          className="hero-video"
          src="/images/technology-hero.jpg"
          alt="Technology hero background"
        />
      </div>
      <div className="hero-overlay"></div>

      <div className="container">
        <div className="hero-content">
          <p className="hero-label">Technology Solutions</p>
          <h1 className="hero-title">
            Transforming Business<br />
            <span className="highlight">Through Technology</span>
          </h1>
          <p className="hero-description">
            We help organizations leverage technology to drive growth,
            optimize operations, and create exceptional experiences.
          </p>
          <a href="#contact" className="btn btn-primary">
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
